module.exports = __webpack_public_path__ + "img/icloud.2b71efc2.svg";